import React, { ReactElement, useEffect, useRef, useState } from "react";
import Loader from "../LogoLoader";
import { Flex } from "../StyledComponents";

interface ComponentProps {
  data;
  children;
  active: boolean;
  action: ({ page }: { page: number }) => void;
  isLoading: boolean;
  page: number;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  style?;
  noMessage?: boolean;
  loader?: ReactElement;
}

const FetchDataComponent = ({
  data,
  children,
  isLoading,
  page,
  setPage,
  active,
  action,
  style,
  noMessage,
  loader,
}: ComponentProps) => {
  const observer = useRef<IntersectionObserver | null>(null); // Define observer type
  const [noMoreElements, setNoMoreElements] = useState(false);

  useEffect(() => {
    action({ page });
  }, []);

  useEffect(() => {
    if (!isLoading && !data.length && !noMessage) {
      setNoMoreElements(true);
    } else {
      setNoMoreElements(false);
    }
  }, [data, isLoading, noMessage]);

  const lastElementRef = useRef<HTMLDivElement>(null); // Define ref type

  useEffect(() => {
    if (!isLoading && data) {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0,
      };

      const handleIntersect: IntersectionObserverCallback = async (entries) => {
        if (entries[0].isIntersecting && active) {
          action({ page: page + 1 });
          setPage(page + 1);
        }
      };

      observer.current = new IntersectionObserver(handleIntersect, options);

      if (lastElementRef.current) {
        observer.current.observe(lastElementRef.current);
      }

      return () => {
        if (lastElementRef.current) {
          observer.current?.unobserve(lastElementRef.current); // Use optional chaining for observer unobserve
        }
      };
    }
  }, [data, isLoading]);

  return (
    <div style={style ? style : {}}>
      {children}
      {isLoading && <>{loader ? loader : <Loader />}</>}
      {!active && !isLoading && !noMessage && (
        <Flex justify="center" align="center">
          {noMoreElements ? (
            <b style={{ padding: "20px 0px" }}>No hay cursos para mostrar</b>
          ) : (
            <b style={{ padding: "20px 0px" }}>No hay más elementos</b>
          )}
        </Flex>
      )}
      <div ref={lastElementRef}></div>
    </div>
  );
};

export default FetchDataComponent;
